import videoFileProcessor from './videoFileProcessor';

function calculateVideoFPS(fileInfo) {
  const videoTrack = fileInfo.videoTracks?.[0];

  if (videoTrack) {
    const duration = videoTrack.movie_duration / videoTrack.movie_timescale;
    return videoTrack.nb_samples / duration;
  } else {
    return null;
  }
}

async function isValidVideoFPS(file, maxFPS) {
  const fileInfo = await videoFileProcessor(file);
  const videoFps = calculateVideoFPS(fileInfo);

  if (videoFps) {
    return videoFps <= maxFPS;
  } else {
    return false;
  }
}

export default isValidVideoFPS;
